import loadable from '@loadable/component';
import React from 'react';

// react-lottie charge lottie-web, qui touche `document` dès son import. Depuis
// Node 21 le global `navigator` existe côté serveur, lottie-web se croit alors
// dans un navigateur et fait planter le rendu serveur (FUNCTION_INVOCATION_FAILED
// sur Vercel en Node 22). L'animation ne sert que dans le navigateur : elle sort
// du bundle serveur, comme le tunnel de WorkshopStandalone.
const Lottie = loadable(() => import('react-lottie'), { ssr: false });

export default function LottieAnimation({ lotti, width, height }) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: lotti,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <div>
      <Lottie options={defaultOptions} height={height} width={width} />
    </div>
  );
}
